import { c as _c } from "react/compiler-runtime";
import { Separator, VStack } from '@chakra-ui/react';
import { ContactBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/ContactBlock';
import { GetStartedBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/GetStartedBlock';
import { HeroBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/HeroBlock';
import { KeyStatsBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/KeyStatsBlock';
import { MasonryGridBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/MasonryGridBlock';
import { MatchBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/MatchBlock';
import { PitchBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/PitchBlock';
import { PricingBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/PricingBlock';
import { QuestionsBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/QuestionsBlock';
import { SocialProofCardBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/SocialProofCardBlock';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { TrackEvent } from '@src/lib/TrackEvent';
import React from 'react';
export const InvestorMatchingLP: React.FC<{
  variantKey?: string;
}> = props => {
  const $ = _c(19);
  const activeContent = useActiveContentContext();
  const variantKey = props.variantKey || "default";
  let t0;
  if ($[0] !== activeContent) {
    t0 = () => {
      activeContent.setSiteSection("landing.investor-matching");
    };
    $[0] = activeContent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useUniversalEffect(t0);
  let t1;
  if ($[2] !== variantKey) {
    t1 = <TrackEvent action="investorMatchingLPViewed" allowDuplicates={false} onlyOnScreen={true} traits={{
      variantKey
    }} />;
    $[2] = variantKey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HeroBlock />;
    t3 = <KeyStatsBlock />;
    t4 = <MatchBlock />;
    t5 = <Separator borderColor="colorPalette.border" />;
    t6 = <SocialProofCardBlock cardSet="set1" />;
    t7 = <PitchBlock />;
    t8 = <Separator borderColor="colorPalette.border" opacity={1} />;
    t9 = <SocialProofCardBlock cardSet="set2" />;
    t10 = <ContactBlock />;
    t11 = <GetStartedBlock />;
    t12 = <QuestionsBlock />;
    t13 = <PricingBlock />;
    t14 = <MasonryGridBlock />;
    $[4] = t10;
    $[5] = t11;
    $[6] = t12;
    $[7] = t13;
    $[8] = t14;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t10 = $[4];
    t11 = $[5];
    t12 = $[6];
    t13 = $[7];
    t14 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t15;
  if ($[17] !== t1) {
    t15 = <VStack align="stretch" bgColor="colorPalette.panel" gap={0} height="full" justify="stretch" width="full">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}</VStack>;
    $[17] = t1;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  return t15;
};